export default {
      id: "ic_right_arrow-usage",
      viewBox: "0 0 11 18",
      url: "/" + "images/icons.3.109.2.svg#ic_right_arrow-usage",
      toString: function () {
        return this.url;
      }
    }